import React from 'react'
import { Button } from '@mui/material';


/**
 * A React component that renders a standalone button with a specific design.
 * 
 * @param {Object} props - The component props.
 * @param {string} [props.text] - The text to display on the button.
 * @param {string} [props.color='primary'] - The button color.
 * @param {Function} props.onClick - The callback function to call when the button is clicked.
 */
const BntStandaloe = ({
  text,
  color = 'primary',
  onClick
}) => {
  return (
    <Button
      size="large"
      variant="outlined" 
      disabled
      color={color || 'primary'}
      onClick={onClick}
      sx={{
        /**
         * Custom styles for the button
         */
        width: '250px',     // Increases the width
        height: '40px',     // Increases the height to accommodate more text
        fontSize: '12px',   // Increases the font size
        padding: '8px 10px',// Adjusts the internal padding
        textTransform: 'none', // Removes the uppercase transformation
        lineHeight: '1.2',  // Adjusts the line spacing
        whiteSpace: 'normal', // Allows automatic line breaks
        display: 'flex',
        flexDirection: 'column', // Stacks the content vertically
        justifyContent: 'center', // Centers the content vertically
        alignItems: 'center' // Centers the content horizontally
      }}
    >
      {'Standalone'}
      <br />
      {'Coming Soon'}
    </Button>
  );
};

/**
 * Exports the BntStandaloe component as the default export.
 */
export default BntStandaloe;